import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import PasswordInput from '../components/PasswordInput';
import GradientSpinner from '../components/GradientSpinner';
import '../App.css';

const LAB_LOGO_KEY = 'labLogoUrl';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [labLogoUrl, setLabLogoUrl] = useState(null);

  useEffect(() => {
    setLabLogoUrl(localStorage.getItem(LAB_LOGO_KEY));
  }, []);

  useEffect(() => {
    if (!token) {
      setError('Invalid or missing reset link. Use the link from your email, or request a new reset from the login page.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!token) return;
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await authAPI.resetPassword({ token, password });
      setSuccess(data?.message || 'Password updated.');
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Could not reset password. Request a new link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App" style={{ height: '100vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div
        className="container"
        style={{
          maxWidth: '500px',
          width: '100%',
          padding: window.innerWidth <= 768 ? '16px' : '24px',
          maxHeight: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden'
        }}
      >
        <div style={{ marginBottom: '12px' }}>
          <Link to="/login" className="back-to-home-btn">
            <span className="back-to-home-icon">←</span>
            Back to sign in
          </Link>
        </div>
        <div className="card auth-screen" style={{ margin: 0 }}>
          <div className="text-center mb-3">
            <img
              src={labLogoUrl || '/logo-labster.jpeg'}
              alt={labLogoUrl ? 'Lab logo' : 'THE LABSTER'}
              style={{
                maxWidth: window.innerWidth <= 768 ? '100px' : '120px',
                width: '100%',
                height: 'auto',
                marginBottom: '12px'
              }}
            />
            <p className="page-subtitle" style={{ marginBottom: '16px' }}>
              Choose a new password
            </p>
          </div>

          {error && <div className="alert alert-error" style={{ marginBottom: '12px' }}>{error}</div>}
          {success && <div className="alert alert-success" style={{ marginBottom: '12px' }}>{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group" style={{ marginBottom: '12px' }}>
              <label className="form-label" style={{ marginBottom: '6px', fontSize: '0.875rem' }} htmlFor="reset-password">
                New password
              </label>
              <PasswordInput
                id="reset-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                autoComplete="new-password"
                style={{ padding: '8px 12px', fontSize: '0.875rem' }}
              />
            </div>
            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label className="form-label" style={{ marginBottom: '6px', fontSize: '0.875rem' }} htmlFor="reset-confirm">
                Confirm password
              </label>
              <PasswordInput
                id="reset-confirm"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={6}
                autoComplete="new-password"
                style={{ padding: '8px 12px', fontSize: '0.875rem' }}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', padding: '10px', fontSize: '0.875rem', marginBottom: '12px' }}
              disabled={loading || !token}
            >
              {loading ? (
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                  <GradientSpinner size={20} />
                  Saving…
                </span>
              ) : (
                'Save new password'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
